import { Container, Grid, Link } from "@mui/material";
import React, { useState, useEffect } from "react";
import Web3 from "web3";
import ConnectScreen from "../Login/connectscreen";
import Loader from "../../../Components/ErroBook/loader";
import ErrorBook from "../../../Components/ErroBook/ntErro"

var web3; 

//Swap contract 
var swapAdd;
var swapAbi;
var swapContract;
const RegisterScreen = () => {
    const [useWallet, setWallet] = useState('');
    const [useEmail, setEmail] = useState('');
    const [usePassword, setPassword] = useState('');
    const [useWalletConnected, setWalletConnected] = useState(false);
    const [useWalletAddress, setWalletAddress] = useState('0x');
    const [useWalletError, setWalletError] = useState(false);
    const [useEmailError, setEmailError] = useState(false);
    const [usePasswordError, setPasswordError] = useState(false);
    const [useWalletMessageError, setWalletMessageError] = useState('Enter a valid wallet address!');
    const [useEmailMessageError, setEmailMessageError] = useState('Enter a valid email address!');
    const [usePasswordMessageError, setPasswordMessageError] = useState('Enter valid password!');
    const [useIncorrectWalletError, setIncorrectWalletError] = useState(false);
    const [useUserBalance, setUserBalance] = useState(false);
    
    
    const [useLoader, setLoader] = useState(false);
    const [useError, setError] = useState(false);
    const [useErrorType, setErrorType] = useState('a');

    useEffect(()=> {
        connectWallet();
        setTimeout(() => {
            setError(false)
            setIncorrectWalletError(false)
        }, 5000)
    },[useError,useIncorrectWalletError]);
    // 3=> chainChanged   
    try {
        window.ethereum.on('connect',  ( _connectInfo => {
            // BSC 0x38
            // BSCTestnet 0x61
            if ( _connectInfo.chainId != "0x38") {
                setErrorType('wrongNetwork')
                setError(false)
                setIncorrectWalletError(true)
            }
        }));
    } catch (error) {
        console.log(error)
    }  
    try{   
        window.ethereum.on('chainChanged', (_chainId => {
            // BSC 0x38
            // BSCTestnet 0x61
            if ( _chainId == "0x38") {
                window.location.reload();
            }else{
                setLoader(true)
                setErrorType('wrongNetwork')
                setError(false)
                setIncorrectWalletError(true)
            }
        })); 
    } catch (error) {
        console.log(error)
    }  
    // 4=> accountsChanged
    try {
        window.ethereum.on('accountsChanged', ( _mAddress => {
            if( _mAddress != "" ){
                setErrorType('walletChanged')
                setError(false)
                setIncorrectWalletError(true)
            }else{
                setWalletConnected(false)
                setErrorType('walletNotConnected')
                // setLoader(true)
                setError(false)
                setIncorrectWalletError(true)
            }
        }));
    } catch (error) {
        console.log('Address: ', error)
    }

    const connectWallet = () => {
        if(typeof Web3 !== 'undefined'){

            web3 = new Web3(window.ethereum);
            try{
            window.ethereum.request({ method: 'eth_chainId' }).then( _chainId => {
                // BSC 0x38
                // BSCTestnet 0x61
                if ( _chainId != "0x38") {
                    setLoader(true)
                    setErrorType('wrongNetwork')
                    setIncorrectWalletError(false)
                    setError(true)
                }
            })
        } catch (error) {
            console.log(error)
        }
            //get connected wallet address
            try {
                window.ethereum.request({ method: 'eth_requestAccounts'}).then( _account => {
                    setWallet(_account.toString())
                    setWalletAddress(_account.toString())
                    setWalletConnected(true)
                    web3.eth.getBalance(_account.toString()).then(bal => {
                        setUserBalance(bal/1e18)
                    }); 
                })
                .catch (error => {
                    setErrorType('walletNotConnected')
                    // setWalletConnected(false)
                    setIncorrectWalletError(false)
                    setError(true)
                });
            } catch (error) {
                setErrorType('noMetamask')
                setIncorrectWalletError(false)
                setError(true)
            }
        }else{
            console.log('Please install metamask to use this page.!')
        }
    }



    const handleInput = ( e, type) => {
        if (type == 'wallet') {
            let value = e.target.value.toLowerCase();
            setWallet( value )
        }else if (type == 'mail') {
            let value = e.target.value;
            setEmail( value )
        } else if (type == 'password'){
            let value = e.target.value;
            setPassword( value )
        }
    }

    const handleRegistration = () => {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; 
        
        if ( useEmail == "") {
            console.log('emptly')
            setErrorType("empty-email")
            setIncorrectWalletError(false)
            setError(true)
            return;
        }else if ( !useEmail.match(pattern) ) {
            console.log('other')
            setErrorType("invalid-email")
            setIncorrectWalletError(false)
            setError(true)
            return;
        }
        setError(false)
        
        if ( useWallet == "" ) {
            setIncorrectWalletError(false)
            setError(true)
            setErrorType('empty-address')
            return;
        }else{
            let wallletchar = useWallet.substring(0, 2);
            if (wallletchar != "0x") {
                setErrorType('invalid-address')
                setIncorrectWalletError(false)
                setError(true)
                return;
            }else{
                if ( useWallet.length != 42) {
                    setErrorType("too-short-address")
                    setIncorrectWalletError(false)
                    setError(true)
                    return;
                }
            }
        }
        setError(false)
        
        if (usePassword == "") {
            setErrorType("empty-password")
            setIncorrectWalletError(false)
            setError(true)
            return;
        }else if ( usePassword.length < 6) {
            setErrorType("too-short-password")
            setIncorrectWalletError(false)
            setError(true)
            return;
        }
        setError(false)
        //Swap contract 
        swapAdd = "0xd456bb4233f8864fec44dbe7f11390d17556420e";
        swapAbi = [{"inputs":[{"internalType":"address","name":"meta","type":"address"},{"internalType":"address","name":"_tax_distribution","type":"address"},{"internalType":"uint256","name":"_tax_rate","type":"uint256"},{"internalType":"uint256","name":"_conversion_rate","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPulled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipPushed","type":"event"},{"inputs":[],"name":"conversion_rate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"failsafe","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"ingame_swapped","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manager","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"meta_swapped","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pullManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner_","type":"address"}],"name":"pushManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_token","type":"address"}],"name":"recoverLostToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"identifier","type":"string"}],"name":"register","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"}],"name":"registered_data","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"registered_users","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"removeFailsafe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceManagement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"setConversionRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"setFailsafe","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"setTaxRate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"}],"name":"setTaxWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"swapInGame","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"swapMeta","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"tax_rate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"}]
        swapContract = new web3.eth.Contract( swapAbi , swapAdd );
        
        setLoader(true)
        // signup api calling
        if( useUserBalance >= 0.001){
            fetch('https://metasnooker.herokuapp.com/api/auth/register',{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    email: useEmail,
                    password: usePassword,
                    address: useWallet
                })
            })
            .then(response => response.json())
            .then( jsonData => {
                console.log('Response Data: ', jsonData)
                if(jsonData.message == "Email-Send"){
                    swapContract.methods.register(jsonData.id).send({from: useWalletAddress}).then( result => {
                        console.log("Content:  " , result)
                        setLoader(false)
                        setErrorType("Email-Send")
                        setIncorrectWalletError(false)
                        setError(true)
                    }).catch (error => {
                        fetch('https://metasnooker.herokuapp.com/api/auth/' + jsonData.id,{
                            method: 'DELETE',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                        })
                        .then(response => response.json())
                        .then( jsonData => {
                            console.log("remove data: ", jsonData)
                            if (error.code == "4001") {
                                setErrorType('metamaskReject-user-not-register')
                                setLoader(false)
                                setError(true)
                                setIncorrectWalletError(true)
                            }else{
                                setErrorType('someThingelse')
                                setLoader(false)
                                setError(true)
                                setIncorrectWalletError(true)
                            }
                        })
                    });
                }else{
                    setLoader(false)
                    setErrorType(jsonData.message)
                    setIncorrectWalletError(false)
                    setError(true)
                }
            })
        }else{
            setLoader(false)
            setErrorType("insufficient-balance")
            setIncorrectWalletError(false)
            setError(true)
        }
    }
    
    return(
        <div className="AppDapp position-relative">
            { useLoader ? 
                <Loader />
                :
                <span />
            }
            {useIncorrectWalletError ?
                <ErrorBook 
                    errorType = {useErrorType}
                />
            :
                <span />
            }
            { useWalletConnected ?
                <Container>
                    <Grid
                        container
                        justifyContent='center'
                        alignContent="space-between"
                        className="div"
                    >
                        <Grid
                            xs={12}
                            sm={8}
                            md={5}
                            lg={7}
                        ></Grid>
                        <Grid
                            xs={11}
                            sm={8}
                            md={7}
                            lg={5}
                            className="text-center mt-sm-5 pt-5"
                        >
                            <Link href="/" className="MS---dashboard--heading d-inline-block position-relative mb-5">
                                Register Account
                            </Link>
                            {useError ?
                                <ErrorBook 
                                    errorType = {useErrorType}
                                />
                            :
                                <span />
                            }
                            <div className="MS---dapp_form px-3 py-5 p-sm-5">
                                <form>
                                    <label className="mb-2">Enter Email</label>
                                    <input 
                                        type='email' 
                                        placeholder="e.g. abc@xyz.com"
                                        className="mb-3"
                                        title={useEmail}
                                        value={useEmail}
                                        onChange={(event,type) =>handleInput(event,'mail')}
                                    />
                                    <label className="mb-2">Enter Wallet Address</label>
                                    <input 
                                        type='text' 
                                        placeholder="0xd12********45F8"
                                        className="mb-3"
                                        title={useWallet}
                                        value={useWallet}
                                        onChange={(event,type) =>handleInput(event,'wallet')}
                                    />
                                    <label className="mb-2">Password</label>
                                    <input 
                                        type='password' 
                                        placeholder="********"
                                        className="mb-3"
                                        value={usePassword}
                                        onChange={(event,type) =>handleInput(event,'password')}
                                    />
                                    <div className="text-right">
                                        <Link href="/forget-password" className="MS---blue-link">
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <button
                                        type="button"
                                        className="MS---Neon--Button btn d-inline-block mt-4 mb-5"
                                        onClick={handleRegistration}
                                    >
                                        Register
                                    </button>
                                    <p className="mb-0">
                                        Already Have An Account? <Link href="/login" className="MS---pink-link">Back to Login</Link>
                                    </p>
                                </form>
                                </div>
                        </Grid>
                        <Grid
                            container
                            xs={12}
                            className="mt-sm-5 py-5 px-sm-5"
                        >
                            <Grid
                                xs={12}
                                sm={8}
                                className="text-center text-sm-left"
                            >
                                <p className="mb-0">Metasnooker © 2022. All Rights Reserved.</p>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={4}
                                className="text-center text-sm-right mt-4 mt-sm-0"
                            >
                                <Link href="/terms" className="MS---blue-link" target="_blank">
                                    Terms & Conditions
                                </Link>
                                &nbsp;&nbsp;&nbsp;
                                <Link href="/privacy-policy" className="MS---blue-link" target="_blank">
                                    Privacy Policy
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            :
                <ConnectScreen 
                    connectFun = {connectWallet}
                />
            }
        </div>
    );
}

export default RegisterScreen;